import { useState } from "react";
import data from "./data";
import { columns, dataForm } from "./formColumn";
import { ICONS } from "@/assets";
import { ColumnMasterPiutang } from "../../../library/FormColumn";

import { ConfigProvider, Space, Table, Button } from "antd";

import CustomModal from "@/components/CustomModal";
import CustomForm from "@/components/CustomForm";
import ButtonExportPDF from "@/components/ButtonExportPDF";
import ButtonExportExcel from "@/components/ButtonExportExcel";

const MasterAnggota = () => {
  const [modalType, setModalType] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const closeModal = () => setModalType(null);

  const handleModal = (type, record) => {
    setModalType(type);
    setSelectedData(record); // Simpan data baris yang dipilih
  };

  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <button onClick={() => handleModal("view", record)}>
          <img src={ICONS.FaDetail} alt="View" />
        </button>

        <button onClick={() => handleModal("edit", record)}>
          <img src={ICONS.FaEdit} alt="Edit" />
        </button>

        <button onClick={() => handleModal("delete", record)}>
          <img src={ICONS.FaTrash} alt="Delete" />
        </button>
      </Space>
    ),
  };

  const extendedColumn = [...ColumnMasterPiutang.columns, actionColumn];

  const renderContent = () => {
    if (modalType === "view") {
      return <CustomForm formColumn={dataForm} selectedData={selectedData} />;
    } else if (modalType === "add") {
      return <CustomForm formColumn={dataForm} />;
    } else if (modalType === "edit") {
      return <CustomForm formColumn={dataForm} selectedData={selectedData} />;
    }
    return null; // No form for delete modal
  };

  const handleSubmit = (values) => {
    console.log("Form Submitted:", values);
    setSelectedData(values); // Update data for Edit modal
    closeModal();
  };

  const handleDelete = () => {
    console.log("Item Deleted:", selectedData);
    closeModal();
  };

  return (
    <div>
      <h1 className="text-4xl font-semibold mb-8">Master Piutang Page</h1>

      <div className="flex justify-between">
        <Button
          type="primary"
          size="large"
          onClick={() => setModalType("add")}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button>

        <div className="flex gap-4">
          <ButtonExportPDF />
          <ButtonExportExcel />
        </div>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          columns={extendedColumn}
          dataSource={data}
          size="middle"
          className={data == "" && `shadow-md`}
        />
      </ConfigProvider>

      {/* Modal Add */}
      <CustomModal
        visible={modalType === "add"}
        onClose={closeModal}
        title="Add User"
        content={renderContent()}
        onSubmit={handleSubmit}
        submitText="Tambah"
      />

      {/* Modal View */}
      <CustomModal
        visible={modalType === "view"}
        onClose={closeModal}
        title="View User"
        content={renderContent()}
        showFooter={false} // No buttons for View mode
        readOnly={true} // Form is read-only
      />

      {/* Modal Edit */}
      <CustomModal
        visible={modalType === "edit"}
        onClose={closeModal}
        title="Edit User"
        content={renderContent()}
        onSubmit={handleSubmit}
        submitText="Save Changes"
      />

      {/* Modal Delete */}
      <CustomModal
        visible={modalType === "delete"}
        onClose={closeModal}
        title={`Delete User ${selectedData?.noAcc} - ${selectedData?.nameAcc}`}
        content={
          <p>Are you sure you want to delete this user?</p> // Simple confirmation message
        }
        showFooter={true}
        onDelete={handleDelete}
        submitText="Delete"
      />
    </div>
  );
};

export default MasterAnggota;
